<template>
    <form @submit.prevent="validar">
        <h6 class="text-primary linea2">Referencias bancarias</h6>
        <div class="alert alert-secondary fade show"  :class="errors.has('Bancarias') && 'alert-danger'" role="alert" v-if="validacion.bancarias>0">
            Debes completar mínimo&nbsp;<b>{{validacion.bancarias}}</b>&nbsp;Referencia<span v-if="validacion.bancarias>1">s</span> Bancaria<span v-if="validacion.bancarias>1">s</span>
        </div>
        <div class="pb-2">
            <referencias-bancarias
                    :previos="previos.elements5"
                    :sync="sync"
                    :lst-intituciones="lstInstituciones"
                    :lst-tipo-cuenta="lstTipoCuenta"
                    name="Bancarias"
                    v-model="datos.bancarias"
                    v-validate="{required:true,lst:validacion.bancarias}"
            ></referencias-bancarias>
        </div>

        <h6 class="text-primary linea2">Referencias personales</h6>
        <div class="alert alert-secondary fade show"  :class="errors.has('Personales') && 'alert-danger'" role="alert" v-if="validacion.personales">
            Debes completar mínimo&nbsp;<b>{{validacion.personales}}</b>&nbsp;Referencia<span v-if="validacion.personales>1">s</span>&nbsp;personal<span v-if="validacion.personales>1">es</span>
        </div>
        <div class="pb-2">
            <referencias-personales
                    :previos="previos.elements6"
                    :sync="sync"
                    :lst-parentesco="lstParentesco"
                    name="Personales"
                    v-model="datos.personales"
                    v-validate="{required:true,lst:validacion.personales}"
            ></referencias-personales>
        </div>

        <div class="col-12 col-md-12 p-1">
            <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block" :class="cargando ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''" :disabled="cargando">Guardar</button>
        </div>
    </form>
</template>

<script>
    import constantes from "../../constantes";
    import _ from 'lodash';
    import {catalogos, persona} from "../../servicios";
    import ReferenciasBancarias from "./referenciasBancarias";
    import ReferenciasPersonales from "./referenciasPersonales";

    export default {
        name: "referencias",
        data: () => ({
            lstTipoActivo: [],
            datos: {
                bancarias: [],
                personales:[],
            },
            listado: constantes.Constantes.tiposActivos,
            lstInstituciones: [],
            lstTipoCuenta: [],
            lstParentesco: [],
            cargando:false,
        }),
        components: {
            ReferenciasBancarias,
            ReferenciasPersonales
        },
        props: {
            validacion:{
                type: Object,
                default:()=>({
                    bancarias:1,
                    personales: 1,
                })
            },
            sync: {
                type: Boolean,
                default: false,
            },
            previos: {
                type: Object
            },
            formulario: {
                type: Object,
                required: true
            },
            tipo: {
                type: Object,
                required: true
            }
        },
        methods: {
            validar: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.cargando=true;
                        this.enviarDatos();
                    } else {
                        this.$toast.show(`Completa el formulario ` + this.formulario.id + " " + this.tipo.titulo);
                        setTimeout(() => {
                            let container = this.$el.querySelector('.alert-danger');
                            container.scrollIntoView();
                        }, 100);
                    }
                });
            },
            catalogosTipos() {
                catalogos.tipoCuentaBancaria().then(r => r.data).then(response => {
                    this.lstTipoCuenta = response;
                });
                catalogos.entidadesBancarias().then(r => r.data).then(response => {
                    this.lstInstituciones = response;
                });
                catalogos.tipoParentesco().then(r => r.data).then(response => {
                    this.lstParentesco = response;
                });
            },
            enviarDatos:_.debounce(function(){
                persona.actualizacionReferenciasBancarias(this.datos.bancarias).then(()=>{
                    persona.actualizacionReferenciasPersonales(this.datos.personales).then(()=>{
                        this.datos.complete=true;
                        this.cargando=false;
                        this.$emit('input',this.datos);
                    })
                });
            },2000),
        },
        created() {
            this.catalogosTipos();

        }
    }
</script>

<style scoped>

</style>
